export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="utama" className="relative min-h-screen flex items-center pt-20" style={{
      backgroundImage: 'url(https://public.readdy.ai/ai/img_res/4246b2183a4fa492ad9de119285bb401.jpg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }}>
      <div className="absolute inset-0 bg-gradient-to-r from-emerald-900/95 via-emerald-800/85 to-transparent"></div>
      
      <div className="relative w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="max-w-3xl">
          <div className="mb-6">
            <span className="inline-block bg-yellow-500 text-emerald-900 px-4 py-2 rounded-full text-sm font-semibold">
              Madrasah Tahfiz Terkemuka
            </span>
          </div>
          
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            Madrasah Tahfiz Al Quran Zawiyah Darul Madad
          </h1>
          
          <p className="text-xl md:text-2xl text-white/90 mb-8 leading-relaxed">
            Melahirkan generasi huffaz yang cemerlang dalam hafazan Al-Quran, berakhlak mulia, dan berprestasi tinggi dalam akademik
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4">
            <button 
              onClick={() => scrollToSection('kemasukan')}
              className="bg-yellow-500 text-emerald-900 px-8 py-4 rounded-full font-semibold text-lg hover:bg-yellow-400 transition-all shadow-lg cursor-pointer whitespace-nowrap"
            >
              Mohon Sekarang
            </button>
            <button 
              onClick={() => scrollToSection('profil')}
              className="bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-white/20 transition-all border-2 border-white cursor-pointer whitespace-nowrap"
            >
              Ketahui Lebih Lanjut
            </button>
          </div>

          <div className="mt-12 grid grid-cols-3 gap-6">
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-yellow-400 mb-2">100+</div>
              <div className="text-white/80 text-sm md:text-base">Pelajar Aktif</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-yellow-400 mb-2">200+</div>
              <div className="text-white/80 text-sm md:text-base">Huffaz Berjaya</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-yellow-400 mb-2">15+</div>
              <div className="text-white/80 text-sm md:text-base">Tahun Pengalaman</div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <button 
          onClick={() => scrollToSection('profil')}
          className="w-10 h-10 flex items-center justify-center text-white cursor-pointer"
        >
          <i className="ri-arrow-down-line text-3xl"></i>
        </button>
      </div>
    </section>
  );
}
